import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import { ViteAppProviders } from './providers/app-providers'
import { ErrorBoundary } from './components/error-boundary'
import { router } from './router'
import '@/styles/globals.css'


ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ViteAppProviders>
        <ErrorBoundary>
          <RouterProvider router={router} />
        </ErrorBoundary>
      </ViteAppProviders>
    </ErrorBoundary>
  </React.StrictMode>,
)
